import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UpCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/UpCircleOutlined";
import AntdIcon from "../components/AntdIcon";
var UpCircleOutlined = function UpCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpCircleOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UpCircleOutlined.displayName = 'UpCircleOutlined';
}
export default /*#__PURE__*/React.forwardRef(UpCircleOutlined);